import jwtDecode from 'jwt-decode';

import { Storage } from '@/enums/storage.enum';

/**
 * Zwraca dane z tokenu
 *
 * @export
 * @param {string} [jwtToken]
 * @returns {({ user: { passwordValidUntil: string; id: string }; exp: number } | undefined)}
 */
export function getTokenData(
  jwtToken?: string
): { user: { passwordValidUntil: string; id: string }; exp: number } | undefined {
  jwtToken = jwtToken || (localStorage.getItem(Storage.TOKEN) as string);
  if (jwtToken) {
    return jwtDecode(jwtToken);
  }
}
